import React , { Component } from 'react'
import './index.css'
import i18n from 'i18next'

export default class LoginHeader extends Component{
    constructor(props) {
        super(props);
        this.state={
            lang: React.cookie.load("bby_lang") ? React.cookie.load("bby_lang") : window._bby_config.lang,
            languageShow: false,
            ...props.customLoginConfig,
        }
        this.languageCont=React.createRef()
    }

    languageShow = (event) =>{
        event.stopPropagation()
        const {languageShow} = this.state
        this.setState({languageShow:!languageShow})
    }

    componentDidMount() {
        document.addEventListener('click', this.hideAllMenu);
    }

    languageChange = (event) =>{
        const s=event.target.parentNode.children;
        for(let i = 0; i <s.length; i++){
            s[i].classList.remove("select");
        }
        event.target.classList.add("select");
        const n = event.target.classList[0];
        React.cookie.save("bby_lang",n)
        i18n.changeLanguage(n);
        this.setState({lang:n})
    }

    hideAllMenu = (event) =>{
        event.stopPropagation()
        const {languageShow} = this.state
        if(languageShow === true){
            this.setState({languageShow:false})
        }
    }

    render() {
        const {languageShow, lang, language, siteName, corpLogoImageUrl, corpLogoSwitch} = this.state;
        const {isMirror, mirrorTime} = this.props;
        let timeCookie = Number(mirrorTime) * 1000;
        let year = new Date(timeCookie).getFullYear();
        let month = new Date(timeCookie).getMonth() + 1;
        if(month < 10){
            month = "0" + month
        }
        let day = new Date(timeCookie).getDate();
        if(day < 10){
            day = "0" + day
        }
        let hour = new Date(timeCookie).getHours();
        if(hour < 10){
            hour = "0" + hour
        }
        let minutes = new Date(timeCookie).getMinutes();
        if(minutes < 10){
            minutes = "0" + minutes
        }
        let seconds = new Date(timeCookie).getSeconds();
        if(seconds < 10){
            seconds = "0" + seconds
        }
        let time = React.language('date.year_month_day',{year,month,day}) + " " + hour + ":" + minutes + ":" + seconds;
        return (
            <div className={"header" + (isMirror ? " isMirror" : "")}>
                {!isMirror && <div className="logo">
                    {corpLogoSwitch && <>
                        <img src={corpLogoImageUrl} alt=""/>
                        <span>{siteName}</span>
                    </>}
                </div>}
                {
                    isMirror && <div className="mirrorHeader">
                        <div className="mirrorTitle">
                            {window.screen.width > 1200 ? React.language('login.mirror.access.title') : React.language('login.mirror.access.title.mobile')}
                            {/* <span className="beta"> (Beta) </span> */}
                        </div>
                        <div className="mirrorMsg">
                            {React.language('login.mirror.header.msg',{time})}
                        </div>
                    </div>
                }
                {language && window.screen.width > 1200 && <div ref={this.languageCont} className={"languageCont" + (isMirror ? " isMirror" : "")}>
                    <div onClick={this.languageShow} className="languageTitle">
                        <span className={"titleItem" + (lang === "zh_cn" ? " select" : "")}>中文</span>/
                        <span className={"titleItem" + (lang === "zh_tw" ? " select" : "")}>繁体</span>/
                        <span className={"titleItem" + (lang === "en_us" ? " select" : "")}>EN</span>
                    </div>
                    {languageShow && <ul onClick={this.languageChange} className="languageList">
                        <li className={lang === "zh_cn" ? "zh_cn select" : "zh_cn"}>简体中文</li>
                        <li className={lang === "zh_tw" ? "zh_tw select" : "zh_tw"}>繁體中文</li>
                        <li className={lang === "en_us" ? "en_us select" : "en_us"}>English</li>
                    </ul>}
                </div>}
            </div>
        )
    }
}